import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo } from 'react';
import * as timeago from 'timeago.js';

import defaultTimeZone from '@/constants/defaultTimeZone';
import { AppointmentAttendance } from '@/types/appointmentAttendance';
import DualTime from '@/ui/components/DualTime/DualTime';
import { daysBetween } from '@/utils/dates';
import formatStaffName from '@/utils/formatStaffName';

const AppointmentMinimalDetails = ({
  appointmentAttendance,
  timeZone = defaultTimeZone
}: {
  appointmentAttendance: Pick<
    AppointmentAttendance,
    'appointment_start_at' | 'appointment_type_name' | 'providers' | 'state'
  >;
  timeZone?: string | null;
}) => {
  const { appointment_type_name, appointment_start_at, state } = appointmentAttendance;
  const now = new Date();
  const startAt = new Date(appointment_start_at);
  return (
    <>
      <DualTime memberTZ={timeZone} dateTime={startAt} />
      <p className="text-md capitalize">{appointment_type_name}</p>
      <p>
        <span className="text-md capitalize">{state} </span>
        <span className="capitalize">
          {now > startAt && +daysBetween(startAt, now) > 1
            ? `${daysBetween(startAt, now, true)} days ago`
            : timeago.format(startAt).toLocaleString()}
        </span>
      </p>

      <div className="flex items-center">
        <FontAwesomeIcon icon={faUsers} className="mr-1" />
        {appointmentAttendance.providers.length ? (
          <ul className="inline space-x-1">
            {appointmentAttendance.providers.map((staff, index) => {
              return (
                <li className="inline-block divide-x divide-gray-200" key={staff.id}>
                  {formatStaffName({ staff })}
                  {index < appointmentAttendance.providers.length - 1 && ', '}
                </li>
              );
            })}
          </ul>
        ) : (
          'None'
        )}
      </div>
    </>
  );
};

export default memo(AppointmentMinimalDetails);
